import styled from 'styled-components'
import { Form } from 'antd'

const StyledFormItem = styled(Form.Item)`
  margin: 0;
`
export { StyledFormItem }
